import { MOCK_MANUFACTURER_MODELS } from "../data";
import { ManufacturerModelForm, ManufacturerModelState } from "../types";

export const initialManufacturerModelForm: ManufacturerModelForm = {
  manufacturer: "",
  year: "",
  masterModel: "",
  modelDescription: "",
  licensedWeight: "",
  frontOverhang: "",
  drive: "",
  wheelbase: "",
  frontAxleDistance: "",
  chassisWeight: "",
  openingBase: "",
  chassisWidth: "",
  maxWidth: "",
  registrationInstruction: "",
  sideLighting: true,
  sideGuard: true,
  mudguard: true,
  extendableChassis: true,
  notes: "",
};

export const initialState: ManufacturerModelState = {
  loading: false,
  list: MOCK_MANUFACTURER_MODELS,
  error: null,
  manufacturerFilter: "ALL",
  masterModelFilter: "ALL",
  yearFilter: "ALL",
  licensingWeightFilter: "ALL",
  isAddModalOpen: false,
  form: initialManufacturerModelForm,
};
